module.exports = __webpack_public_path__ + "img/解决方案_动力_灰.1c0de702.svg";